import React, { useEffect, useState } from "react";
import moment from "moment";
import SpecialSlots from "./SpecialSlots";
import { useLocation, useNavigate } from "react-router-dom";
import StatusComp from "../../../components/StatusComp";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import Slot from "../../SiteAdmin/Slot/Slot";

const days_arr = [
  { day: "Monday", type: 1, start_time: "", end_time: "", toggle: false },
  { day: "Tuesday", type: 2, start_time: "", end_time: "", toggle: false },
  { day: "Wednesday", type: 3, start_time: "", end_time: "", toggle: false },
  { day: "Thursday", type: 4, start_time: "", end_time: "", toggle: false },
  { day: "Friday", type: 5, start_time: "", end_time: "", toggle: false },
  { day: "Saturday", type: 6, start_time: "", end_time: "", toggle: false },
  { day: "Sunday", type: 7, start_time: "", end_time: "", toggle: false },
];

const AdminSlotMainComp = ({ list }) => {
  const [activeTab, setActiveTab] = useState("week");
  const [alertData, setAlertData] = useState([]);
  const [alertDatas, setAlertDatas] = useState([]);
  const location = useLocation();
  const superAdmin = location.state?.superAdmin;
  const { type, data } = location.state;
  // console.log("superAdmin", superAdmin);
  const [days, setDays] = useState([...days_arr]);
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const navigate = useNavigate();

  // useEffect(() => {
  //   const slotDays = JSON.parse(localStorage.getItem("slotDays"));
  //   if (slotDays) {
  //     setActiveTab(slotDays);
  //   } else {
  //     setActiveTab("week");
  //     localStorage.setItem("slotDays", JSON.stringify("week"));
  //   }
  // }, []);

  const handleTab = (days) => {
    setActiveTab(days);
    localStorage.setItem("slotDays", JSON.stringify(days));
  };

  const getAlertTypes = (site_id) => {
    if (site_id) {
      let formdata = new FormData();
      formdata.append("knf_company_site_id", site_id);
      post(URL.ADMIN_DAY_LIST, formdata)
        .then((res) => {
          if (res?.data?.length > 0) {
            let temp = [...days_arr];
            let data = [...res?.data];
            let day_type = [1, 2, 3, 4, 5, 6, 7];
            data?.map((item, ind) => {
              if (day_type?.includes(item?.type)) {
                let indexToReplace = day_type.findIndex(
                  (i) => i === item?.type
                );
                temp[indexToReplace] = {
                  ...temp[indexToReplace],
                  toggle: true,
                  start_time: item?.start_time
                    ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
                    : "",
                  end_time: item?.end_time
                    ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
                    : "",
                };
              }
            });
            setDays(temp);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const getAlertEscalation = (site_id) => {
    if (site_id) {
      let formdata = new FormData();
      formdata.append("knf_company_site_id", site_id);
      post(URL.ADMIN_DATE_LIST, formdata)
        .then((res) => {
          if (res?.data?.length > 0) {
            let temp = [];
            let data = [...res?.data];
            data?.map((item, ind) => {
              let obj = {
                ...item,
                toggle: item?.start_time && item?.end_time ? true : false,
                date: item?.for_date,
                for_date: moment(item?.for_date).format("DD-MM-YYYY"),
                start_time: item?.start_time
                  ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
                  : "",
                end_time: item?.end_time
                  ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
                  : "",
              };
              temp.push(obj);
            });
            setDates(temp);
            setSelectedDate(temp?.[0]?.id);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setDates([]);
    }
  };

  useEffect(() => {
    if (data?.id) {
      getAlertTypes(data?.id);
      getAlertEscalation(data?.id);
    }
  }, []);

  console.log("days", days);

  return (
    <div className="">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "week" ? "active" : ""}`}
          onClick={() => handleTab("week")}
        >
          Week days
        </button>
        <button
          className={`tab-btn ${activeTab === "special" ? "active" : ""}`}
          onClick={() => handleTab("special")}
        >
          Special Holidays
        </button>
      </div>

      <div>
        {activeTab == "week" && (
          <Slot
            superAdmin={superAdmin}
            days={days}
            setDays={setDays}
            handleSubmit={() => {}}
            noEditable={true}
          />
        )}
        {activeTab == "special" && (
          <SpecialSlots
            superAdmin={superAdmin}
            dates={dates}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            setDates={setDates}
          />
        )}
      </div>
    </div>
  );
};

export default AdminSlotMainComp;
